import { combineReducers } from 'redux';
import ClientLinkReducer from '../service/ClientLinkReducer'

const reducer = combineReducers({
    clientLink : ClientLinkReducer
});

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducer.js